/**
 * 
 * @param {*} elt 
 * @param {*} pointerEvent 
 * @returns 
 */
export function whereAmIClicked(elt, pointerEvent) {
    const x = pointerEvent.clientX - elt.getBoundingClientRect().x
    return minmax(0, x, elt.getBoundingClientRect().width)
    
}

export function minmax(min, value, max) {
    return Math.max(min, Math.min(value, max))
}